import {
  aboutUs,
  authentication,
  cart,
  charitableGiving,
  contactUs,
  customerService,
  designer,
  designerList,
  ipForm,
  isItalistLegitimate,
  main,
  press,
  privacy,
  productDetail,
  productList,
  resetMyPassword,
  reviews,
  terms,
} from './metadata';

const metadata = {
  aboutUs,
  authentication,
  cart,
  charitableGiving,
  contactUs,
  customerService,
  designer,
  designerList,
  ipForm,
  isItalistLegitimate,
  main,
  press,
  privacy,
  productDetail,
  productList,
  resetMyPassword,
  reviews,
  terms,
};

export default metadata;
